import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import dayjs from "dayjs";
import { Classes } from "@blueprintjs/core";
import classNames from "classnames";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
function TimelineEvent({ date, children }) {
  return /* @__PURE__ */ jsx("div", { className: "tg-timeline-event", children: /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ jsx("div", { className: "tg-timeline-circle" }),
        children,
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: { marginLeft: 5 },
            className: classNames(Classes.TEXT_SMALL, Classes.TEXT_MUTED),
            children: [
              "(",
              dayjs(date).fromNow(),
              ")"
            ]
          }
        )
      ]
    }
  ) });
}
export default TimelineEvent;
